/**
 * InteractionDateCell - Displays interaction date with import source indicator
 *
 * Specialized cell component for displaying interaction dates in table/grid views.
 * Shows date with import source indicator (EverTrue vs Import).
 */

import moment from 'moment';
import { Icon, ButtonTooltip } from '@evertrue/et-components';
import PropTypes from 'prop-types';

/**
 * Displays interaction date with import source indicator
 * @param {Object} interaction - Interaction object with date and source info
 */
const InteractionDateCell = ({ interaction = {} }) => {
  const { date_occurred, created_at, update_source } = interaction;

  const interaction_date = moment(date_occurred || created_at).format('MM/D/YYYY');

  return (
    <div className="interaction-table-cell">
      {update_source === 'IMPORTER' ? (
        <ButtonTooltip trigger={<Icon icon="exit-to-app" rotate={90} before className="icon-muted" disableTitle />}>
          Last Updated via Import
        </ButtonTooltip>
      ) : (
        <ButtonTooltip trigger={<Icon icon="community" before className="icon-muted" disableTitle />}>
          Last Updated via EverTrue
        </ButtonTooltip>
      )}
      {interaction_date && interaction_date !== 'Invalid date' && (
        <span className="interaction-table-cell date">{interaction_date}</span>
      )}
    </div>
  );
};

InteractionDateCell.propTypes = {
  interaction: PropTypes.object,
};

export default InteractionDateCell;
